module.exports = __webpack_public_path__ + "static/media/ht.3e541c48.svg";